import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import useContext from '../../../../../../hooks/useContext';
import store from '../../../../../../store';
import { queryActions } from '../../../../../../store/querySlice';
import { SimpleButton } from '../../../../../common';
import { ApiaComponentContextPrimitive } from '../../../apiaComponent/ApiaComponentContext';
import AdditionalFiltersModal from './AdditionalFiltersModal';

const ApiaFinderNavbar = ({
  hideAdditionalFilters,
  onSearch,
}: {
  hideAdditionalFilters?: boolean;
  onSearch?: () => void;
}) => {
  const { fieldId } = useContext(ApiaComponentContextPrimitive);
  const dispatch = useAppDispatch();
  const state = useAppSelector(
    (globalState) => globalState.querySlice.queries[fieldId],
  );
  return (
    <>
      {!hideAdditionalFilters && <AdditionalFiltersModal />}
      <SimpleButton
        {...window.getVariant('primary')}
        title={window.BTN_SEARCH}
        size="sm"
        isLoading={state.loading > 0}
        onClick={() => {
          void dispatch(
            queryActions.search({
              fieldId,
              forceSearch: true,
            }),
          );
          if (onSearch) onSearch();
        }}
      >
        {window.BTN_SEARCH}
      </SimpleButton>
      <SimpleButton
        {...window.getVariant('outline')}
        title={window.FINDER_FILTER_DELETE_FILTERS}
        size="sm"
        onClick={async () => {
          await dispatch(
            queryActions.deleteFilters({
              listId: fieldId,
            }),
          );
          void store.dispatch(
            queryActions.refresh({
              fieldId,
            }),
          );
        }}
      >
        {window.FINDER_FILTER_DELETE_FILTERS}
      </SimpleButton>
    </>
  );
};

export default ApiaFinderNavbar;
